<template>
<div>
    <div class="panel mb-0">
        <div class="panel-hdr d-block pt-4 p-3">
            <div class="ml-auto text-right mb-3">
                <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                    :data="exportData"
                    :fields="exportFields"
                    :header="exportHeaders"
                    type="csv"
                    :escapeCsv="false"
                    :name="exportFileName">
                    <span>CSV</span>
                </exportCSV>
                <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                    <span class="mr-3">PDF</span>
                    <i class="arrow-down fas fa-angle-down"></i> 
                </button> -->
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-4 align-items-center justify-content-start">
                    <div class="dataTables_filter mb-2">
                        <label class="d-flex mb-0">
                            <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search')" v-model="searchMember" @keypress.enter="searchMemberList">
                            <button class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0" @click="searchMemberList()">
                                <i class="fas fa-search"></i>
                            </button>
                        </label>
                    </div>
                </div>
                <div v-show="selectedTabView == 'active'" class="col-sm-12 col-md-4 mb-2"> 
                    <div class="form-group">
                        <div class="input-group">
                            <div class="input-group-prepend w-100">
                                <label class="input-group-text border-right-0">
                                    <i class="fas fa-calendar-check"></i>
                                </label>
                                <multiselect :value="selectedVisit" label="text" track-by="id" :options="lastVisits" :searchable="false" :show-labels="false" openDirection="below" @select="filterLastVisit"></multiselect>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mb-2 col-sm-12 col-md-4"> 
                    <div class="form-group">
                        <div class="input-group">
                            <div class="input-group-prepend w-100">
                                <label class="input-group-text border-right-0">
                                    <i class="fas fa-birthday-cake"></i>
                                </label>
                                <multiselect :value="selectedBday" label="text" track-by="id" :options="birthdays" :searchable="false" :show-labels="false" openDirection="below" @select="filterBirthday"></multiselect>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <a class="link text-primary" @click="clearFilter">{{$t('button_link.clear_filter')}}</a>
        </div>
        <div class="panel-container">
            <div class="panel-content">
                <ul class="nav nav-tabs" >
                    <li class="nav-item" v-for="membershipTab in $i18n.messages[$i18n.locale].tab.membershipTabs" :key="membershipTab.id">
                        <a :class="{'active': selectedMembershipTab == membershipTab.id}" class="nav-link" @click="filterMembership(membershipTab.id)">{{membershipTab.text}}</a>
                    </li>
                </ul>
                <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                    <b-spinner label="Loading..."></b-spinner>
                </div>
                <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">{{$t('table.no_records')}}</div>
                <div class="dataTables_wrapper dt-bootstrap4" v-if="!isSpinnerShow && totalEntries != 0">
                    <div class="row justify-content-end mt-2">
                        <div class="col-auto pt-2">
                            <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
                        </div>
                        <div class="col-auto">
                            <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination"></b-pagination>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 overflow-auto">
                            <b-table striped hover bordered :fields="fields" :items="memberLists" responsive>
                                <template #cell(index)="data">
                                    {{ data.index + startPage }}
                                </template>
                                <template #cell(img)="data">
                                    <img class="profile-image-md rounded-circle" :src="data.item.memberImage != '' ? getMemberImage(data.item.memberImage) : require('@/assets/image/icon/profile.png')"/>
                                </template>
                                <template #cell(bday)="data">
                                    {{data.item.memberDob == '0000-00-00' ? '-' : data.item.memberDob}}
                                </template>
                                <template #cell(membership)="data">
                                    <h6 v-if="data.item.memberVip == '0' && data.item.memberVvip == '0' && data.item.memberVvvip == '0'">
                                        <span class="badge border border-secondary text-secondary fw-400">N/A</span>
                                    </h6>
                                    <h6 class="d-inline-block mr-2" v-if="data.item.memberVip != '0'">
                                        <span class="badge badge-primary">{{membershipTabs[1].text}}</span>
                                    </h6>
                                    <h6 class="d-inline-block mr-2" v-if="data.item.memberVvip != '0'">
                                        <span class="badge badge-danger">{{membershipTabs[2].text}}</span>
                                    </h6>
                                    <h6 class="d-inline-block mr-2" v-if="data.item.memberVvvip != '0'">
                                        <span class="badge badge-warning">{{membershipTabs[3].text}}</span>
                                    </h6>
                                </template>
                                <template #cell(gallery)="data">
                                    <a class="link text-primary" :title="$t('button_link.view_update', {'item': $t('table.header.gallery')})" @click="editGallery(data.item)">
                                        <i class="fal fa-images fs-xl"></i>
                                    </a>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <memberGallery ref="memberGallery"></memberGallery>
</div>
</template>
<script>
import MemberGallery from './Member_Gallery'
import moment from 'moment'
import {handleSessionExpired, setReturnData} from './../../../../assets/js/dashboard/dashboard.js'
export default {
    name: 'memberList',
    components:{
        MemberGallery
    },
    data(){
        let selectedTab = this.$i18n.messages[this.$i18n.locale].tab.membershipTabs[0].id
        return{
            selectedTabView: "active",
            searchMember: "", isSpinnerShow: false,
            searchFilter: "",
            selectedVisit:{},
            selectedBday: {}, birthdayFilter: "",
            membershipTabs: [], selectedMembershipTab: selectedTab,
            memberData: [],
            memberLists: [],
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
            exportHeaders: [],exportData: [], exportFields: {}, exportFileName: "", memberExportData: []
        }
    },
    computed:{
        fields(){
            return[
                { key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "img", label: "", thClass: 'thead-themed text-center', tdClass: 'text-center'},
                { key: "memberDisplayName", label: this.$i18n.t('table.header.name'), thClass: 'thead-themed align-middle', tdClass: 'align-middle',sortable: true},
                { key: "mobile", label: this.$i18n.t('table.header.contact'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "bday", label: this.$i18n.t('table.header.birthday'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "membership", label: this.$i18n.t('table.header.membership'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "gallery", label: this.$i18n.t('table.header.gallery'), thClass: 'thead-themed align-middle', tdClass: 'align-middle text-center'},
            ]
        },
        lastVisits(){
            return [
                { id: 'all', text: this.$i18n.t('member.lastVisits.all')},
                { id: 'one', text: this.$i18n.t('member.lastVisits.one')},
                { id: 'three', text: this.$i18n.t('member.lastVisits.three')},
                { id: 'six', text: this.$i18n.t('member.lastVisits.six')},
                { id: 'more', text: this.$i18n.t('member.lastVisits.more')}
            ]
        },
        birthdays(){
            return [
                { id: 'all', text: this.$i18n.t('member.birthdays.all')},
                { id: 'today', text: this.$i18n.t('member.birthdays.today')},
                { id: 'last', text: this.$i18n.t('member.birthdays.last')},
                { id: 'this', text: this.$i18n.t('member.birthdays.this')},
                { id: 'next', text: this.$i18n.t('member.birthdays.next')}
            ]
        },
    },
    watch:{
        "$i18n.locale"(val){
            if(Array.isArray(this.selectedBday)){
                this.selectedBday = this.selectedBday[0]
            }
            if(Array.isArray(this.selectedVisit)){
                this.selectedVisit = this.selectedVisit[0]
            }
            var b = Object.assign({}, this.selectedBday)
            var v = Object.assign({}, this.selectedVisit)
            
            this.selectedVisit = this.lastVisits.filter(obj=> obj.id == v.id)
            this.selectedBday = this.birthdays.filter(obj=> obj.id == b.id)

            this.setExportData(this.memberExportData)
        }
    },
    methods:{
        filterMemberByView(tab){
            this.page = 0;
            this.selectedTabView = tab;
            this.clearFilter()
        },
        clearFilter(){
            this.searchMember = this.searchFilter = this.birthdayFilter = "" 
            this.selectedVisit = this.lastVisits[0];
            this.selectedBday = this.birthdays[0];
            this.selectedMembershipTab = "all"
            this.filterMemberList(this.selectedMembershipTab, this.selectedVisit, this.searchFilter, this.birthdayFilter);
        },
        getMemberImage(img){
            return img;
        },
        searchMemberList(){
            this.page = 0;
            this.currentPage = 1;
            this.searchFilter = this.searchMember == "" ? "" : "&search=" + this.searchMember;
            this.filterMemberList(this.selectedMembershipTab, this.selectedVisit, this.searchFilter, this.birthdayFilter);
        },
        filterMembership(id){
            this.page = 0;
            this.currentPage = 1;
            this.selectedMembershipTab = id;
            this.filterMemberList(this.selectedMembershipTab, this.selectedVisit, this.searchFilter, this.birthdayFilter);
        },
        filterLastVisit(item){
            this.page = 0;
            this.currentPage = 1;
            this.selectedVisit = item;
            this.filterMemberList(this.selectedMembershipTab, this.selectedVisit, this.searchFilter, this.birthdayFilter);
        },
        filterBirthday(item){
            this.selectedBday = item
            var now = new Date()
            switch(item.id){
                case"today":
                    this.birthdayFilter = "&dobStart[day]=" + now.getDate() + "&dobEnd[day]=" + now.getDate() + "&dobStart[month]=" + (now.getMonth()+1) + "&dobEnd[month]=" + (now.getMonth()+1) + "&dobStart[year]=" + now.getFullYear() + "&dobEnd[year]=" + now.getFullYear()
                    break;
                case"last":
                    this.birthdayFilter = this.getBirthdayFilter(new Date(now.getFullYear() - (now.getMonth() > 0 ? 0 : 1), (now.getMonth() - 1 + 12) % 12, 1), new Date(now.getFullYear(), now.getMonth(), 0))
                    break;
                case"this":
                    this.birthdayFilter = this.getBirthdayFilter(new Date(now.getFullYear(), now.getMonth(), 1), new Date(now.getFullYear(), now.getMonth() + 1, 0))
                    break;
                case"next":
                    this.birthdayFilter = this.getBirthdayFilter(new Date(now.getFullYear(), now.getMonth() + 1, 1), new Date(now.getFullYear(), now.getMonth() + 2, 0))
                    break;
                default:
                    this.birthdayFilter = ""
                    break;
            }
            this.filterMemberList(this.selectedMembershipTab, this.selectedVisit, this.searchFilter, this.birthdayFilter);
        },
        getBirthdayFilter(startDate, endDate){
            var startDay = "dobStart[day]=" + startDate.getDate();
            var endDay = "dobEnd[day]=" + endDate.getDate();

            var startMonth = "dobStart[month]=" + (startDate.getMonth()+1);
            var endMonth = "dobEnd[month]=" + (endDate.getMonth()+1);

            var strFilter = "&" + startDay + "&" + endDay + "&" + startMonth + "&" + endMonth ;
            return strFilter ;
        },
        getLastVisitDate(_lastVisit){
            var strFilter = "";
            var curDate = new Date();
            var curMonth = curDate.getMonth();

            var startDate, endDate, newStartMonth, newEndMonth = null;

            if(_lastVisit == "all"){
                strFilter = "";
            }else if(_lastVisit == "more"){
                startDate = "";

                newEndMonth = curMonth - 6;
                endDate = Math.round(this.setNewDate(new Date(), newEndMonth)/1000);
            }else{
                switch(_lastVisit){
                    case"one":
                        newStartMonth = curMonth - 1;
                        
                        startDate = Math.round(this.setNewDate(new Date(), newStartMonth)/1000);
                        endDate = Math.round(curDate/1000);
                        break;
                    case"three":  
                        newStartMonth = curMonth - 3;
                        startDate = Math.round(this.setNewDate(new Date(), newStartMonth)/1000);

                        newEndMonth = curMonth - 1;
                        endDate = Math.round(this.setNewDate(new Date(), newEndMonth)/1000);
                        break;
                    case"six":
                        newStartMonth = curMonth - 6;
                        startDate = Math.round(this.setNewDate(new Date(), newStartMonth)/1000);

                        newEndMonth = curMonth - 3;
                        endDate = Math.round(this.setNewDate(new Date(), newEndMonth)/1000);
                        break;
                    default:
                        startDate = endDate = "";
                        break;
                }
                strFilter = "&startVisitDate=" +  startDate + "&endVisitDate=" + endDate;
            }
            return strFilter
        },
        filterMemberList(mID, lvItem, search, birthday){
            var mFilter = mID == "all" ? "" : "&" + mID + "=1";
            var lvFilter = this.getLastVisitDate(lvItem.id);
            var strFilter = mFilter + lvFilter + search + birthday;

            this.setMemberList(strFilter)
        },
        handlePagination(pg){
            if(pg != null){
                this.page = pg - 1
                this.filterMemberList(this.selectedMembershipTab, this.selectedVisit, this.searchFilter, this.birthdayFilter);
                //document.getElementById('btnToTop').click(); 
            }
        },
        setNewDate(newDate, newMonth){
            if(newDate.getMonth() == newMonth){ newDate.setDate(0); }

            newDate.setMonth(newMonth);
            newDate.setHours(0,0,0);
            newDate.setMilliseconds(0);

            return newDate;
        },
        setExportData(members){
            this.exportFields = {}
            this.exportFields["#"] = "index";
            this.exportFields[(this.$i18n.t('table.header.name')).toUpperCase()] = "name"
            this.exportFields[(this.$i18n.t('table.header.contact')).toUpperCase()] = "contact"
            this.exportFields[(this.$i18n.t('table.header.birthday')).toUpperCase()] = "birthday"
            this.exportFields[this.membershipTabs[1].text] = this.membershipTabs[1].text;
            this.exportFields[this.membershipTabs[2].text] = this.membershipTabs[2].text;
            this.exportFields[this.membershipTabs[3].text] = this.membershipTabs[3].text;
            
            this.exportData = [];
            for(var i=0; i<members.length; i++){
                var data = {}
                data["index"] = i+1;
                data["name"] = members[i].memberDisplayName
                data["contact"] = "+" + (members[i].mobile).toString()
                data["birthday"] = members[i].memberDob == '0000-00-00' ? '-' : members[i].memberDob
                data[this.membershipTabs[1].text] = members[i].memberVip == '0' ? "-" : "Yes"
                data[this.membershipTabs[2].text] = members[i].memberVvip == '0' ? "-" : "Yes"
                data[this.membershipTabs[3].text] = members[i].memberVvvip == '0' ? "-" : "Yes"
                this.exportData.push(data)
            }

            var type = this.$i18n.messages[this.$i18n.locale].tab.memberTabLists.filter(obj=> obj.id == this.selectedTabView)
            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.my_salon_member`) + " (" + type[0].text + ")"
            this.exportHeaders = [header, this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24),  " "];
            this.exportFileName =  header.split(" ").join("_") +  this.$msg.REPORT.CSV
        },
        async getMembershipTags(){
            let $vm = this
                
            var init = ["memberVip", "memberVvip", "memberVvvip"];
            $vm.membershipTabs.push({id: "all", text: "All"});
            await $vm.$axios({
                method: 'get', 
                url: this.$api.MEMBER_CONFIGURE,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                var results = response.data.vip;

                for(var i=0; i<results.length; i++){
                    $vm.membershipTabs.push({id: init[i], text: results[i]});
                    $vm.selectedMembershipTab = $vm.membershipTabs[0].id
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        async setMemberList(strFilter){
            this.isSpinnerShow = true
            var result = await this.getMemberList("?page=" + this.page + strFilter)
            var retData = setReturnData(result.result, result.count, this.page)
            this.memberLists = retData.result;
            this.totalEntries = result.count;
            this.totalPage = retData.totalPage;

            this.startPage = retData.startPage;
            this.endPage = retData.endPage;

            this.isSpinnerShow = false; 
            var exportResult = await this.getMemberList("?" + strFilter)
            this.memberExportData = exportResult.result
            this.setExportData(exportResult.result)
        },
        async getMemberList(strFilter){    
            let $vm = this
            let QUERY_STRING = strFilter +  "&showHide=" + (this.selectedTabView == "active" ? "0" : "1") 
            let url = this.$api.BIZ_MEMBER + QUERY_STRING

            var result = {}
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) { 
                result = response.data
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result
        },
        editGallery(item){
            this.$refs.memberGallery.editMemberGallery(item)
        }
    },
    async mounted(){
        let $vm = this;
        await $vm.getMembershipTags();
        $vm.filterMemberList($vm.selectedMembershipTab, $vm.selectedVisit, $vm.searchFilter, $vm.birthdayFilter);

        $vm.selectedVisit = $vm.lastVisits[0]
        $vm.selectedBday = $vm.birthdays[0]
    }
}
</script>
<style scoped>
.link, .nav-link{
    cursor: pointer;
}
</style>